import React from 'react';
import { PNGS, SVGS } from '../../../assets';
import './waba-loader.scss';
import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';
import { useWabaLoader } from '@zonofi/gandalf-utilities';

interface WabaLoaderProps {}

export const WabaLoader: React.FC<WabaLoaderProps> = ({}) => {
  // useWabaLoader();

  const renderIcons = () => {
    return (
      <div className="waba-setup-icons" style={{ marginTop: '80px' }}>
        <img src={SVGS.MetaIcon} alt="meta-icon" />
        <img src={SVGS.RefreshIcon} alt="refresh-icon" />
        <img src={SVGS.ZotokLogo} alt="zotok-apps-logo" />
      </div>
    );
  };

  const renderLoader = () => {
    return (
      <div className="waba-setup-loader-container">
        <div className="waba-setup-loader-container-loader"></div>
      </div>
    );
  };
  return (
    <div
      // style={{  }}
      className="waba-launch primary-font-regular"
    >
      {renderIcons()}
      {renderLoader()}

      <div
        style={{
          marginBottom: '36px',
          marginRight: '48px',
          marginLeft: '48px',
          textAlign: 'center',
          width: 'auto',
        }}
        className="waba-setup-message font-14-regular-primary"
      >
        <div
          style={{ marginBottom: '10px' }}
          className="waba-setup-status-text font-16-bold-tertiary"
        >
          WABA Creation in progress...
        </div>
        The setup is continuing in a new tab. Please follow the steps there to
        complete your WABA embedded sign up.
      </div>

      <div className="waba-launch-footer">
        <ZoButton
          onClick={() => {}}
          label={'Back'}
          startIcon={<img src={SVGS.LeftArrowBlue} alt="" />}
          className="waba-launch-footer-back"
        />
        <ZoButton
          isLoading={false}
          onClick={() => {}}
          label={'Launch Embedded Signup'}
          className="waba-launch-footer-continue"
        />
      </div>
    </div>
  );
};
